import { render, staticRenderFns } from "./ModalSendPayment.vue?vue&type=template&id=67d966fa&scoped=true&"
import script from "./ModalSendPayment.vue?vue&type=script&lang=ts&"
export * from "./ModalSendPayment.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSendPayment.vue?vue&type=style&index=0&id=67d966fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d966fa",
  null
  
)

export default component.exports